import type { FaireProductEntity } from "../../entity_types/product";

export const p_8gjmt5sjye: FaireProductEntity = {
  token: "p_8gjmt5sjye",
  type: "product",
  name: "Gluten Free Snack 1oz |Classic Sea Salt Lily Pops|Makhana",
  brandToken: "b_2ppngtaknh",
  brandName: "Karma Wellness Kitchen",
  imageUrl:
    "https://cdn.faire.com/fastly/0a1a89244c0bf1c3ba2570072d57a80086e8edfdc8497fa5111a69845ab39d72.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/824b7a76f3ee14958fa3675da9971c6709be7d4d53042535a74df70c4316cb33.png",
    "https://cdn.faire.com/fastly/110f06441119cd1f6f19a46883c4ff79efbaccb8378336045bc3d9d33a75af62.png",
    "https://cdn.faire.com/fastly/1a359c59a5c5ada760dd9e9528cb0176be3bd8b388bf0dda9ebb98b2cbf175db.png",
    "https://cdn.faire.com/fastly/d912ea93958dc36cc20be65b7f037797257d14b4b13638dc12f621d67f637bcd.png",
  ],
  priceDollars: 4.43,
  description:
    "• Protein rich, super food snack\n\n• You can eat them or mix them with salads, soups and trail mix\n\n•This is a perfect snack for all classic sea salt lovers\n\n• 1 oz Bags\n\n\n",
  tags: [],
  msrpDollars: 6.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:44.862Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
